module.exports = __webpack_public_path__ + "static/media/Ashley Pandya.7f2e91da.png";